import { Component, Input, OnInit } from '@angular/core';
import { ColumnConfig } from 'material-dynamic-table';

@Component({
  selector: 'app-employee-delivery-address-list',
  templateUrl: './employee-delivery-address-list.component.html',
  styleUrls: ['./employee-delivery-address-list.component.scss'],
  standalone: false,
})
export class EmployeeDeliveryAddressListComponent implements OnInit {
  @Input() column: ColumnConfig;
  @Input() row: any;

  constructor() {}

  ngOnInit(): void {}

  showAddress(defaultAddress: any): string {
    return defaultAddress !== 'undefined'
      ? defaultAddress?.addressName
        ? `<strong>${defaultAddress?.addressName}: </strong>${defaultAddress?.formattedAddress}`
        : defaultAddress?.formattedAddress
      : '';
  }
}
